import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "dialog",
    onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resolve(false)))
  }, {
    title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createTextVNode("Neuložené změny", -1)
    ]))]),
    body: _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createElementVNode("p", null, "Na aktuální stránce máte neuložené změny.", -1)
    ]))]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resolve(true))),
        "data-bs-dismiss": "modal"
      }, " Uložit "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resolve(false))),
        "data-bs-dismiss": "modal"
      }, " Zahodit ")
    ]),
    _: 1
  }, 512))
}